import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    seriesOptions: [],
    carOptions: []
  },
  mutations: {
    setSeriesOptions(state, options) {
      state.seriesOptions = options
    },
    setCarOptions(state, options) {
      state.carOptions = options
    }
  },
  actions: {
    updateSeriesOptions({ commit }, options) {
      commit('setSeriesOptions', options)
    },
    updateCarOptions({ commit }, options) {
      commit('setCarOptions', options)
    }
  },
  getters: {
    seriesOptions: state => state.seriesOptions,
    carOptions: state => state.carOptions
  }
})